import { iconNames } from "./iconNames";
import { DiagonalLineIcon } from "./icons";
import { AddIcon } from "./icons/AddIcon";
import { CheckIcon } from "./icons/CheckIcon";
import { ChevronIcon } from "./icons/ChevronIcon";
import { CloseIcon } from "./icons/CloseIcon";
import { DotIcon } from "./icons/DotIcon";
import { GraphIcon } from "./icons/GraphIcon";
import { IndeterminateCheckIcon } from "./icons/IndeterminateCheckIcon";
import { LogOutIcon } from "./icons/LogOutIcon";
import { MoonIcon } from "./icons/MoonIcon";
import { SearchIcon } from "./icons/SearchIcon";
import { SettingsIcon } from "./icons/SettingsIcon";
import { ShoppingCartIcon } from "./icons/ShoppingCartIcon";
import { SunIcon } from "./icons/SunIcon";

/**
 * DAS-4283: Add aria-labels to icons to improve accessibility
 */

export interface IconProps {
  /**
   * The name of the icon to render.
   *
   * This should match one of the predefined icon names.
   */
  name?: (typeof iconNames)[number];
}

export function Icon({ name }: IconProps) {
  switch (name) {
    case "close":
      return <CloseIcon />;
    case "graph":
      return <GraphIcon />;
    case "search":
      return <SearchIcon />;
    case "check":
      return <CheckIcon />;
    case "sun":
      return <SunIcon />;
    case "settings":
      return <SettingsIcon />;
    case "log-out":
      return <LogOutIcon />;
    case "moon":
      return <MoonIcon />;
    case "chevron-up":
      return <ChevronIcon direction="up" />;
    case "chevron-down":
      return <ChevronIcon direction="down" />;
    case "chevron-left":
      return <ChevronIcon direction="left" />;
    case "chevron-right":
      return <ChevronIcon direction="right" />;
    case "diagonal-line":
      return <DiagonalLineIcon />;
    case "dot":
      return <DotIcon />;
    case "shopping-cart":
      return <ShoppingCartIcon />;
    case "add":
      return <AddIcon />;
    case "indeterminate-check":
      return <IndeterminateCheckIcon />;

    default:
      throw new Error(`Icon "${name}" does not exist.`);
  }
}
